<template>
  <div>
    <!-- <InterForm @querySubmit="queryHandler" :prentType="prentType" :shopList="shopList" isToBeProcessed /> -->
    <!--    FBA -&ndash;&gt; 待处理 btns： 有 '导出发货单'、'批量生成拣货'、'批量修改物流公司'-->
    <!--    大包 -&ndash;&gt; 待处理 btns： 有 '导出发货单'、'批量生成拣货'、'批量修改物流公司'-->
    <!--    小包 -&ndash;&gt; 待处理 btns： 有 '导出发货单'、'批量生成拣货'、'批量修改物流公司'、'批量获取运单号'-->
    <InterBtnBox @refeash="getDataSource" :selectedRows="selectedRows" modify-btn @overEmit="getDataSource" :singleProduct="query.singleProduct"
      :prentType="prentType" pack-btn />
    <InterList :dataSource="dataSource" tableType="toBeProcessed" :clean="clean" :total="query.total" :singleProduct="query.singleProduct"
      @pageChange="pageChangeCall" @selectChange="selectChangeCall" @change="getDataSource" layout="logistics" ref="interlist"
      @refeash="getDataSource" :prentType="prentType" :forwarder="$attrs.forwarder">
    </InterList>
  </div>
</template>

<script>
import InterForm from '@/views/outOfStock/internationalShipment/components/InterForm'
import InterList from "@/views/outOfStock/internationalShipment/components/InterList";
import InterBtnBox from "@/views/outOfStock/internationalShipment/components/InterBtnBox";
import { shipTask } from "@/apis/outStock";
import { deliveryStatus, deliveryTypes } from "@/views/outOfStock/internationalShipment/tabs/index";

export default {
  title: '待处理',
  name: "toBeProcessed", // 待处理
  props: {
    prentType: String,
    shopList: {
      type: Array,
      required: true
    }
  },
  components: {
    InterForm,
    InterList,
    InterBtnBox
  },
  data() {
    return {
      query: {
        current: 1,
        pageSize: 20,
        total: 0
      },
      clean: false,
      selectedRows: [],
      dataSource: []
    }
  },
  mounted() {
    // InterForm 组件created 时已近触发了 queryHandler， 无需请求
    // this.getDataSource()
  },
  methods: {
    queryHandler: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      }
      this.query.current = 1
      this.getDataSource()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource()
    },
    selectChangeCall: function (rows) {
      this.selectedRows = rows
      console.log('tab',this.selectedRows)
    },
    getDataSource: function () {
      // console.log(this.query)
      // 获取列表数据
      this.selectedRows = []
      this.clean = true
      const params = {
        ...this.query,
        pageNum: this.query.current,
        deliveryStatus: deliveryStatus['toBeProcessed'],
        deliveryType: deliveryTypes[this.prentType]
      }
      shipTask(params).then(res => {
        const { data: { total = 0, records = [] } } = res
        records.forEach(item => {
          let text = ''
          if (item.channelNo && item.logisticsChannelDTOList) {
            item.logisticsChannelDTOList.forEach(item_son => {
              if (item_son.channelNo == item.channelNo) {
                text = item_son.channelName
              }
            })
          }
          item.channelNo = text
        })
        this.query.total = total
        this.dataSource = records
        // const {}
      }).finally(_ => {
        this.clean = false
      })
    },

  }
}
</script>

<style scoped>
</style>